import React, {useState, useEffect} from "react";
import { useDispatch } from "react-redux";
import { Row, Col, message } from "antd";
import { CustomLabel, SectionCardDark } from "../../../../Common/style";
import { useIsMobile } from "../../../../Hooks";
import { error_message } from "../../../../Constant";
import { BOOK_APPOINTMENT_HA, BOOK_APPOINTMENT_HI, BOOK_APPOINTMENT_MGNESA, BOOK_APPOINTMENT_VH } from "../../../../Services/endpoints";
import { postApi } from "../../../../Services/apiService";
import BookVisit from "../BookMedicalVisitTemplate";
import BookedVisitsTemplate from "../BookedVisitsTemplate";
import { setAppointmentDetails } from "../../../../Redux/AppointmentDetails/action";
import PAGE_CONSTANTS from "../constant";
import { getAdditionalTestArray } from "../../../../Utils";
import RaisedModal from "../AppointmentModal/raisedModal";
import { encrypt } from "../../../../Services/AESEncryptionDecryption";
import { setInitialMemberDetails } from "../../../../Redux/BookMedicalVisit/action";
import "./style.css";


const MemberTabDetails = ({ selectedMember, bookedAppointment, applicationNumber, humsApiCall }) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  

  const bookAppointment = async (requestBody, tpa) => {
    const getPath = () => {
      switch(tpa){
        case PAGE_CONSTANTS?.TPA_HA:
          return BOOK_APPOINTMENT_HA;
        case PAGE_CONSTANTS?.TPA_HI:
          return BOOK_APPOINTMENT_HI;
        case PAGE_CONSTANTS?.TPA_VH:
          return BOOK_APPOINTMENT_VH;
        case PAGE_CONSTANTS?.TPA_MG:
          return BOOK_APPOINTMENT_MGNESA;
        default:
          return null;
      }
    }
    const path = getPath();
    try {
      const encryptedRequest = encrypt(JSON?.stringify(requestBody));
      const result = await postApi(path, {
        encodedString: encryptedRequest
      });
      if(result?.data?.responseCode === 200){
          toggleModal();
          humsApiCall();
          dispatch(setAppointmentDetails({
            Application_Number: requestBody?.Application_Number,
            Insured_Info: requestBody?.Insured_Info?.filter((insured) => insured?.Appointment_preferred_time1),
          }));
      }
      else{
        message.error(result?.data?.errorMessage);
      }
    } catch (error) {
      message.error(error_message?.common_error);
     }
  };
  const medicalTestUndergoBlock = (testSet, additionalTests) => {

    const testArray = testSet ? testSet?.split(",") : getAdditionalTestArray(additionalTests)
    return (
      <>
        <CustomLabel
          style={{ marginBottom: "14px" }}
          font_size="18"
          font_weight="bold"
        >
          {"Medical tests to undergo"}
        </CustomLabel>
        <SectionCardDark>
          {testArray?.map((testName, i) => (
            <CustomLabel key={i} className="mb-20" font_size="14" font_weight="normal">
              {testName?.trim()}
            </CustomLabel>
          ))}
        </SectionCardDark>
      </>
    );
  };
  const precautionToFollowBlock = () => {
    return (
      <>
        <CustomLabel
          style={{ marginBottom: "17px", marginTop: "33px" }}
          font_size="18"
          font_weight="bold"
        >
          {"Precautions to Follow"}
        </CustomLabel>
        <SectionCardDark>
        <CustomLabel
          style={{ marginBottom: "15px", marginTop: "5px" }}
          font_size="16"
          font_weight="bold"
        >
          {"Documents"}
        </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "To ensure that the medicals are smoothly conducted, we request you to kindly adhere to the following instructions / precautions."
            }
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {"Display an original Photo ID proof Eg: Pan Card/Driving license/Voter ID Card/Passport/Employee ID & self-attested copy to be submitted at the diagnostic center."}
          </CustomLabel>
            <CustomLabel
            style={{ marginBottom: "15px", marginTop: "5px" }}
            font_size="16"
            font_weight="bold"
          >
            {"Medical Tests"}
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "Follow 12 hours of fasting if any of your medical tests is lipid profile or FBS. Do not consume tea, coffee or any other beverages; however, you can drink water."
            }
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "Do not pass urine for at least one hour before medicals, if your tests include Ultrasound."
            }
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "Please wear comfortable clothes especially for TMT (if required). (Also, in case of TMT test, we request male customers to shave chest hair to ensure that TMT test is conducted smoothly.)"
            }
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "Sign all the requisite documents after completing the medicals & avoid signing on the blank form."
            }
          </CustomLabel>
          <CustomLabel className="mb-20" font_size="14" font_weight="normal">
            {
              "Diagnostic center may click your photo at the time of medicals for verification so please co-operate."
            }
          </CustomLabel>
        </SectionCardDark>
      </>
    );
  };
  const CustomCardWrapper = (props) => {
    const { children } = props;
    return <div className={isMobile ? "" : "card"}>{children}</div>;
  };
  useEffect(() => {
    if(selectedMember && applicationNumber){
      dispatch(setInitialMemberDetails({
        applicationNumber,
        memberId: selectedMember?.MemberId
      }))
    }
  },[selectedMember, applicationNumber, dispatch])
  return (
    <section>
      <Row justify="space-between" gutter={[32, { xs: 32 }]}>
        <Col lg={24} md={24} className="member-details">
          <CustomCardWrapper>
            <Row gutter={[38, 24]}>
              <Col md={15} className="l-col">
                {bookedAppointment ? (
                  <BookedVisitsTemplate
                    bookedAppointment={bookedAppointment}
                  />
                ) : (
                  <BookVisit
                    selectedMember={selectedMember}
                    bookAppointment={bookAppointment}
                  />
                )}
              </Col>
              <Col md={9} className="r-col">
                {(selectedMember?.MedicalTestSetName || selectedMember?.MedicalTest) &&
                  medicalTestUndergoBlock(selectedMember?.MedicalTestSetName, selectedMember?.MedicalTest)}
                {precautionToFollowBlock()}
              </Col>
            </Row>
          </CustomCardWrapper>
        </Col>
      </Row>
      <RaisedModal
        open={isModalOpen}
        onClose={toggleModal}
        memberName={selectedMember?.FirstName}
        memberId={selectedMember?.MemberId}
      />
    </section>
  );
};

export default MemberTabDetails;
